// Copyright 2026. WebPros International GmbH. All rights reserved.

export const BREAKPOINTS = {
    XS: 480,
    SM: 768,
    MD: 992,
    LG: 1200,
    XL: 1600,
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;

export const up = (px: number) => `@media (min-width: ${px}px)`;

export const down = (px: number) => `@media (max-width: ${px - 0.05}px)`;

export const between = (min: number, max: number) =>
    `@media (min-width: ${min}px) and (max-width: ${max - 0.05}px)`;
